"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Alert = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _themes = require("../../themes");

var _Icon = require("../../atoms/Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = {
  "alert": "alert__alert___a51Ax",
  "icon": "alert__icon___1mD-6",
  "title": "alert__title___21h8h",
  "message": "alert__message___3vp70",
  "success": "alert__success___yI-4G",
  "info": "alert__info___udps6",
  "warning": "alert__warning___1QMg-",
  "error": "alert__error___3Iv4r",
  "title--only-child": "alert__title--only-child___3D3LR",
  "viewport": "alert__viewport___1gBbr"
};

var Alert = function Alert(_ref) {
  var className = _ref.className,
      type = _ref.type,
      title = _ref.title,
      message = _ref.message,
      children = _ref.children,
      style = _ref.style,
      compileWithTheme = _ref.compileWithTheme;
  return React.createElement("div", {
    className: compileWithTheme((0, _classnames["default"])(styles.alert, styles[type], className)),
    style: style
  }, React.createElement(_Icon.Icon, {
    glyph: "exclamation-in-circle",
    className: styles.icon,
    width: 20,
    height: 20
  }), React.createElement("div", {
    className: styles.viewport
  }, children || React.createElement(React.Fragment, null, React.createElement("div", {
    className: (0, _classnames["default"])(styles.title, !message ? styles['title--only-child'] : '')
  }, title), React.createElement("div", {
    className: styles.message
  }, message))));
};

exports.Alert = Alert;

var _default = (0, _themes.withTheme)(Alert);

exports["default"] = _default;